/** File uploaded in the Attachments section of a customer, vendor, PO, SO or expense. */
export interface Attachment {
  id: string;
  name: string;
  mimeType?: string;
  /** Bytes. */
  size: number;
  /** Y-m-d, e.g. expiry date of a certificate or contract. */
  validUntil?: string;
  uploadedBy?: string;
  uploadedAt?: string;
}

/** Resources that accept attachments (API path segment). */
export type AttachmentOwner = 'customers' | 'vendors' | 'purchase-orders' | 'sales-orders' | 'expenses';

/** Accepted files: images, PDF, Excel and Word (must match Attachment::EXTENSIONS in the API). */
export const ATTACHMENT_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'pdf', 'xls', 'xlsx', 'doc', 'docx'];

/** Max size per file (10 MB, must match Attachment::MAX_KB in the API). */
export const ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024;
